import { HTS_CLASSIFICATION_TOPIC_BY_ID, HtsTopicKind } from '@evaltick/shared';
import type { HtsQuestionInput } from '@/services/api';

export const HtsQuestionBehavior = {
  RecordOnly: 'RECORD_ONLY',
  HardGate: 'HARD_GATE',
  Sensitive: 'SENSITIVE',
  Suitability: 'SUITABILITY',
  Readiness: 'READINESS',
} as const;
export type HtsQuestionBehavior = (typeof HtsQuestionBehavior)[keyof typeof HtsQuestionBehavior];

export const deriveBehaviorFromInitialValues = (initialValues: HtsQuestionInput): HtsQuestionBehavior => {
  if (initialValues.isSensitive) return HtsQuestionBehavior.Sensitive;
  if (initialValues.hardGateRule) return HtsQuestionBehavior.HardGate;
  if (initialValues.classificationTopic) {
    return HTS_CLASSIFICATION_TOPIC_BY_ID[initialValues.classificationTopic]?.kind === HtsTopicKind.Readiness
      ? HtsQuestionBehavior.Readiness
      : HtsQuestionBehavior.Suitability;
  }
  return HtsQuestionBehavior.RecordOnly;
};
